import type { JSX } from "react";
import { useCallback } from "react";
import * as React from "react";
import classnames from "classnames";

import { useVisibilityObserver } from "../../../hooks/useVisibilityObserver.web";
import { NavigationTabItem } from "../../NavigationTabItem/NavigationTabItem.web";

import type { TabContentProps } from "./TabContent.types";
import styles from "./TabContent.web.css";

const groupsWithSidePadding = [
  "SwimlaneCardGroup",
  "OddsBoostCardGroup",
  "PopularSwimlaneCardGroup",
  "RacingSwimlaneCardGroup",
  "GamingCardGroup",
  "FilteredCouponCardGroup",
  "RacesByTimeRangeCardGroup",
  "FutureRacingCardGroup",
  "VirtualEventDetailsCard",
  "QuicklinksGridCardGroup",
  "BroadcastsCard",
  "LottoCard",
  "PromotionsCardGroup",
  "ObbEventPopularsCard",
  "ObbOnboardingCardsCardGroup",
];

const externalSettingsViews = ["ppb:tbd:card:embeddedView:personalDetails", "ppb:tbd:card:embeddedView:notifications"];

export const TabContent: React.FC<TabContentProps> = ({
  items,
  isFavouriteMarketsTab,
  dispatchFetchCardsFromList,
}): JSX.Element => {
  const hasRacesByTimeRangeCardGroup = items.some(({ typename }) => typename === "RacesByTimeRangeCardGroup");

  const observerShowCallback = useCallback(
    (urn: string): void => {
      dispatchFetchCardsFromList(urn, items, undefined, !hasRacesByTimeRangeCardGroup);
    },
    [items, dispatchFetchCardsFromList, hasRacesByTimeRangeCardGroup],
  );

  const { observe, visibility } = useVisibilityObserver(
    isFavouriteMarketsTab || hasRacesByTimeRangeCardGroup
      ? { onShow: observerShowCallback }
      : { onFirstShow: observerShowCallback },
  );

  return (
    <div className={styles.tabContent}>
      {items.map(({ urn, typename }, index): JSX.Element => {
        const tabItemStyle = classnames(styles.tabItem, {
          [styles.cardItem]: !groupsWithSidePadding.includes(typename),
          [styles.externalSettingsView]: externalSettingsViews.includes(urn),
        });

        return (
          <div
            key={`${index}-${urn}`}
            ref={(node): void => {
              observe(node, urn);
            }}
            className={tabItemStyle}
            data-urn={urn}
          >
            <NavigationTabItem urn={urn} typename={typename} visible={!!visibility[urn]} />
          </div>
        );
      })}
    </div>
  );
};
